import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('accident_benefits_set', '/accident_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
